import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiClient } from '@/services/api/client'
import { InstanceResolver } from '@/util/instanceResolver'

export interface MaintenanceStatus {
  maintenance: boolean
  scope?: string
  html?: string
}

const namespace = 'status'

export class StatusServiceFactory {
  static create(): StatusService {
    return InstanceResolver.isSingle() ?
      new SingleInstanceStatusService() :
      new MultiInstanceStatusService()
  }
}

export interface StatusService {
  brandMaintenance(brand: string): Promise<Either<Error, MaintenanceStatus>>
}

export class SingleInstanceStatusService implements StatusService {
  /**
   * SINGLEインスタンスではブランドメンテナンスという状態は存在しない。
   * 全体メンテナンスorメンテナンスなしのみであり、全体メンテナンスであれば、
   * そもそもこのコードにはたどり着かない。
   * したがって、APIコールは行わず、常にfalseを返す。
   */
  async brandMaintenance(_brand: string): Promise<Either<Error, MaintenanceStatus>> {
    return new Right({ maintenance: false })
  }
}

export class MultiInstanceStatusService implements StatusService {
  async brandMaintenance(brand: string): Promise<Either<Error, MaintenanceStatus>> {
    try {
      const response = await ApiClient.get(`/api/${brand}/status/maintenance`)

      log.debug({ service: `${namespace}/maintenance`, response })

      return new Right(response.body.data)
    } catch (error) {
      log.error({ error })

      return new Left(error)
    }
  }
}
